function DownloadButton({ platform, link, image, Icon }) {
  const isInactive = link === "#";
  const baseClass = Icon ? 'icon-button' : 'image-button';
  const className = `${baseClass} ${isInactive ? 'inactive' : ''}`;
  const title = isInactive ? `${platform} - Coming Soon` : `Go to ${platform}`;

  const content = Icon
    ? <Icon className={className} title={title} />
    : <img src={image} alt={title} className={className} />;

  if (isInactive) {
    return content;
  }

  return (
    <a href={link} target="_blank" rel="noopener noreferrer" className="download-button">
      {content}
    </a>
  );
}
export default DownloadButton;